var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputCode',{attrs:{"language":"html","height":"40vh"},on:{"blur":_vm.update},model:{value:(_vm.buffer.htmlContent),callback:function ($$v) {_vm.$set(_vm.buffer, "htmlContent", $$v)},expression:"buffer.htmlContent"}})}
var staticRenderFns = []

export { render, staticRenderFns }